import { useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * Zestaw checkboxów zgód RODO. Zwraca stan przez callback.
 * Wymagane: privacy + orders. Opcjonalne: marketing + electronic.
 */
export default function ConsentCheckboxes({ values, onChange, error }) {
  const set = (key, v) => onChange({ ...values, [key]: v });

  const allChecked =
    values.rodo && values.privacy && values.orders && values.marketing && values.electronic;

  const toggleAll = () => {
    const target = !allChecked;
    onChange({
      rodo: target,
      privacy: target,
      orders: target,
      marketing: target,
      electronic: target,
    });
  };

  const items = [
    {
      key: "rodo",
      required: true,
      label: (
        <>
          Zapoznałem/am się z{" "}
          <Link to="/rodo" target="_blank" rel="noopener noreferrer" className="text-[#1f3a8a] underline font-semibold">
            klauzulą informacyjną RODO
          </Link>
          . *
        </>
      ),
    },
    {
      key: "privacy",
      required: true,
      label: (
        <>
          Przeczytałem i akceptuję{" "}
          <Link to="/polityka-cookies" target="_blank" className="text-[#1f3a8a] underline font-semibold">
            Politykę Prywatności
          </Link>
          . *
        </>
      ),
    },
    {
      key: "orders",
      required: true,
      label: "Wyrażam zgodę na przetwarzanie moich danych osobowych w celu realizacji zamówień. *",
    },
    {
      key: "marketing",
      required: false,
      label: "Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych, w tym profilowania.",
    },
    {
      key: "electronic",
      required: false,
      label: "Wyrażam zgodę na otrzymywanie informacji handlowych za pośrednictwem środków komunikacji elektronicznej.",
    },
  ];

  return (
    <div className="sm:col-span-2 space-y-3 bg-slate-50 border border-slate-200 rounded-lg p-4" data-testid="consents">
      <button
        type="button"
        onClick={toggleAll}
        data-testid="consent-toggle-all"
        className="text-xs font-bold text-[#1f3a8a] uppercase tracking-wider hover:underline"
      >
        {allChecked ? "Odznacz wszystkie" : "Zaznacz wszystkie"}
      </button>
      <div className="border-t border-slate-200" />
      {items.map((it) => (
        <label key={it.key} className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer">
          <input
            type="checkbox"
            checked={!!values[it.key]}
            onChange={(e) => set(it.key, e.target.checked)}
            data-testid={`consent-${it.key}`}
            className="mt-0.5 accent-[#1f3a8a]"
          />
          <span>{it.label}</span>
        </label>
      ))}
      {error && (
        <div className="rm-error-text" data-testid="consent-error">
          Zaakceptuj wymagane zgody (oznaczone *).
        </div>
      )}
    </div>
  );
}
